angular.module('listingOverviewModule').component('listingSubways', {
    templateUrl: 'listingSubways/listingSubways.html',
    bindings: {
        doNotDefer: '@',
        subwayHtml: '@', // HTML string for the subway section
        greatSchoolsParams: '<', // JSON object for great schools parameters
        rpcLocalSchoolsUrl: '@', // URL for RPC local schools
    },
    controller: ['$sce', '$element', '$timeout', function ($sce, $element, $timeout) {
        var self = this;
        this.uniqueId = `schools_popup_${Math.random().toString(36).substr(2, 9)}`;
        
        // Initialize schools only when the component is visible
        this.checkVisibilityAndInit = function () {
            if (self.doNotDefer) {
                self.addSchools();
                return;
            }
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        self.addSchools();
                        observer.disconnect(); // Stop observing after initialization
                    }
                });
            });

            observer.observe($element[0]);
        };

        this.addSchools = function () {
            const schoolElement = $element[0].querySelector('.w_schools');
            if (schoolElement) {
                new Schools(schoolElement, {
                    customId: self.uniqueId,
                });
            }
        };

        // Initialize component
        this.$onInit = function () {
            // Trust the passed subway HTML for rendering
            if (self.subwayHtml) {
                self.trustedSubwayHtml = $sce.trustAsHtml(self.subwayHtml);
            }

            // Start visibility check
            $timeout(() => {
                this.checkVisibilityAndInit();
            });
        };
    }],
});
